import React, { useState, useEffect } from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import CommonBanner from "../component/CommonBanner";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import BlogImg1 from "../assets/images/blog-1.png";
import BlogImg2 from "../assets/images/blog-2.png";
import BlogImg3 from "../assets/images/blog-3.png";
import BlogImg4 from "../assets/images/blog-4.png";
import BlogImg5 from "../assets/images/blog-5.png";
import BlogImg6 from "../assets/images/blog-6.png";
import BlogImg7 from "../assets/images/blog-7.png";
import BlogImg8 from "../assets/images/blog-8.png";
import BlogImg9 from "../assets/images/blog-9.png";
import { Link } from "react-router-dom";

function NewsEvents() {

  return (
    <>
      <div className="main blog-page">
        <Header />
        <CommonBanner title="Blogs" />
        <div className="blog-list common-padding">
          <Container>
          <div className="common-header">
                <h2 className="mb-0">News<span>&</span>Events</h2>
            </div>
            <Row className="row-gap-4">
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg1} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Market Trends, News, Renting</p>
                    <h3>Real Estate: CPI Shelter Forecast, October 2025</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg2} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Housing Trends Report, Market Trends</p>
                    <h3>Buyers: Results from the Real Estate Consumer Housing Trends Report 2025</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg3} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Housing Trends Report, Market Trends</p>
                    <h3>Sellers: Results from the Real Estate Consumer Housing Trends Report 2025</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg4} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Affordability, Market Trends, News</p>
                    <h3>Fed Cuts Rates, but Powell Says December Cut Is No Guarantee</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg5} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Housing Trends Report, Renting</p>
                    <h3>Renters: Results from the Real Estate Consumer Housing Trends Report 2025</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg6} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Market Reports</p>
                    <h3>Real Estate Home Value and Home Sales Forecast (October 2025)</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg7} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Affordability, Market Trends, News</p>
                    <h3>Mortgage Rates Drift Lower During Government Data Blackout</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg8} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Market Trends, News, Renting</p>
                    <h3>Construction catches up with demand, giving renters an affordability break</h3>
                  </div>
                </Link>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <Link className="blog-item">
                  <div className="blog-image">
                    <img src={BlogImg9} alt="Blog 1" />
                  </div>
                  <div className="blog-content">
                    <p>Market Reports, Market Trends</p>
                    <h3>Lower mortgage rates extend housing momentum into fall (September market report)</h3>
                  </div>
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default NewsEvents;
